// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatMuteSetBody = {
  chatId: string;
  duration:
    | "fifteenMinutes"
    | "oneHour"
    | "threeHours"
    | "eightHours"
    | "twentyFourHours"
    | "indefinite";
};

export type typeChatMuteSetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    chatId: string;
    muteState: "off" | "timed" | "indefinite";
    mutedUntil?: string | null;
  };
};

export type typeChatMuteSetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatMuteSetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatMuteSetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatMuteSetBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    duration: {
      type: "string",
      enum: [
        "fifteenMinutes",
        "oneHour",
        "threeHours",
        "eightHours",
        "twentyFourHours",
        "indefinite",
      ],
    },
  },
  required: ["chatId", "duration"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatMuteSet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatMuteSetBody);
  }

  return async function postChatMuteSet(
    payload: typeChatMuteSetBody,
  ): Promise<typeChatMuteSetOutput200 | typeChatMuteSetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatMuteSet" failed before calling the network. #67114cf30adc`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#67114cf30adc" },
        },
        data: null,
      } as typeChatMuteSetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat-mute/set`,
      httpMethod: "POST",
      options,
    })) as typeChatMuteSetOutput200 | typeChatMuteSetOutput400;
  };
}
